
export default {
    "fr" : {
        "messages":{
            required : "Ce champ est obligatoire",
            email : "Adresse mail invalide",
            max_value : "Le champ {field} doit avoir une valeur inférieur ou égale à {max_value}"
        }
    }
}